import gql from "graphql-tag";
import { useIsAuthenticated } from "@zapier/promotions/esm/hooks";
import { isBrowser } from "@zapier/promotions/esm/utils";
export const currentUserQuery = gql `
  query currentUserQuery {
    currentUser: currentUserV2 {
      id
    }
  }
`;
export const useCurrentAccountId = (props = {}) => {
    const { isAuthenticated, error, isLoading } = useIsAuthenticated(props);
    const response = {
        accountId: undefined,
        error: error ? "Error loading current account ID." : undefined,
        isLoading,
    };
    if (!isAuthenticated || !isBrowser()) {
        return response;
    }
    const currentAccountId = localStorage.getItem("currentAccountId");
    return {
        ...response,
        accountId: currentAccountId ? parseInt(currentAccountId) : undefined,
    };
};

// @zapier/upsells@5.0.1 (c64b11b3c)
